"use client";

import { useCommandPaletteHotkey } from "../_hooks/useCommandPaletteHotkey";
import { CommandPalette } from "./CommandPalette";
import type { PaletteSurface } from "../_logic/types";

interface CommandPaletteMountProps {
  /** Server-derived. Gates items like Payments (see ENG-770). */
  isNowadaysAdmin: boolean;
  /** Which surface this mount is. See `PaletteSurface`. */
  surface: PaletteSurface;
}

/**
 * Single mount point for the command palette: binds the global hotkey and
 * renders the dialog.
 *
 * Exists so a surface adds one element rather than a hook plus a component, and
 * so the hotkey can never be bound without the dialog that services it being
 * rendered.
 *
 * @param props - `isNowadaysAdmin` and `surface`, forwarded for item gating.
 * @returns The palette dialog.
 */
export const CommandPaletteMount = ({ isNowadaysAdmin, surface }: CommandPaletteMountProps) => {
  // Hooks
  useCommandPaletteHotkey();

  // Render
  return <CommandPalette isNowadaysAdmin={isNowadaysAdmin} surface={surface} />;
};
